import { report } from 'report';
import { FTUXType } from '../../Player/PlayerProperty/Progress/FTUXType';
import { AnyBoosterType, BoosterType, PreBoosterType } from './BoosterType';

export interface IBoosterSettings {
    localizationKey: string;
    texture: string;
    ftuxRequirement?: FTUXType;
}

export const BoosterDataMap: Record<AnyBoosterType, IBoosterSettings> = {
    [BoosterType.JOKER]: {
        localizationKey: 'Joker',
        texture: 'joker_reward',
        ftuxRequirement: FTUXType.JOKER,
    },
    [BoosterType.UNDO]: {
        localizationKey: 'Undo',
        texture: 'undo_reward',
        ftuxRequirement: FTUXType.UNDO,
    },
    [BoosterType.TNT]: {
        localizationKey: 'boosterTNT',
        texture: 'gas_can_reward',
        ftuxRequirement: FTUXType.TOOLBOX_UNLOCK,
    },
    [BoosterType.SHUFFLE]: {
        localizationKey: 'boosterShuffle',
        texture: 'shuffle_reward',
        ftuxRequirement: FTUXType.SHUFFLE_BOOSTER,
    },
    [BoosterType.BULLS_EYE]: {
        localizationKey: 'boosterBullseye',
        texture: 'bullseye-reward',
        ftuxRequirement: FTUXType.BULLSEYE_BOOSTER,
    },
    [BoosterType.PLUS_FIVE]: {
        localizationKey: 'Plus 5 Booster',
        texture: 'shop_5_cards',
    },
    [BoosterType.PLUS_ONE]: {
        localizationKey: 'Card',
        texture: 'extra_card_reward',
    },
    [BoosterType.PLUS_THREE]: null,

    // todo implement with preBoosters
    [PreBoosterType.REMOVE_THREE]: {
        localizationKey: 'RemoveThreePreBoosterShortName',
        texture: 'booster_remove',
    },
    [PreBoosterType.JOKER]: {
        localizationKey: 'JokerPreBoosterShortName',
        texture: 'booster_joker',
    },
    [PreBoosterType.CANISTER]: {
        localizationKey: 'CanisterPreBoosterShortName',
        texture: 'booster_canister',
    },
} as const;

export function getBoosterData(type: keyof typeof BoosterDataMap): IBoosterSettings {
    const data = BoosterDataMap[type];
    if (!data) {
        report('Unable to find data for given booster type', {
            once: true,
            tags: { type },
            sampleRate: 0.1,
        });
        return {
            localizationKey: 'localizationKey',
            texture: 'blank',
        };
    }
    return data;
}
